import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { BUSINESS_TOOL_MODE } from 'constants/businessTool';
import { useBusinessToolSessionStore, useBusinessToolStore } from 'store/useBusinessToolStore';
import { getSetBusinessToolMode } from 'store/useBusinessToolStore/selectors';
import { getSetBusinessPlanType } from 'store/useBusinessToolStore/selectors';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { IWorkspaceBusinessPlansProps } from 'pages/Workspace/types';

import { IBusinessPlanType } from 'interfaces/businessPlan';
import { SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';
import { useHeaderLogic } from 'components/Header/HeaderLogicProvider';

import { WorkspaceBusinessPlanItem } from './WorkspaceBusinessPlanItem/WorkspaceBusinessPlanItem';
import { BusinessPlanButtonList } from '../BusinessPlanButtonList/BusinessPlanButtonList';
import { BusinessPlanSectionTitle } from '../BusinessPlanSectionTitle/BusinessPlanSectionTitle';

import styles from './WorkspaceBusinessPlans.module.scss';

export const WorkspaceBusinessPlans: FC<IWorkspaceBusinessPlansProps> = ({ businessPlan }) => {
  const { t } = useTranslation();
  const { isPayedSubscription } = useHeaderLogic();

  const setBusinessToolMode = useBusinessToolSessionStore(getSetBusinessToolMode);
  const setBusinessPlanType = useBusinessToolStore(getSetBusinessPlanType);
  const subscriptionPlan = useUserSubscriptionStore(getUserSubscription)?.currentSubscription.subscriptionPlan;
  const isLightSubscription = subscriptionPlan === SUBSCRIPTION_PLAN.LIGHT;

  const handleNavigate = (type: IBusinessPlanType) => {
    setBusinessToolMode(BUSINESS_TOOL_MODE.EDIT);
    setBusinessPlanType(type);
  };

  return (
    <>
      <ContentWrapper>
        <BusinessPlanSectionTitle title={t('createBusinessPlan')} />
        <Box className={styles.buttonContainer}>
          <BusinessPlanButtonList showAvailablePlansCount />
        </Box>
      </ContentWrapper>

      <ContentWrapper marginTop={'16px'}>
        <BusinessPlanSectionTitle title={t('projects')} />

        <Box className={styles.cardList}>
          {businessPlan.content.map((eachBusinessPlan) => (
            <WorkspaceBusinessPlanItem
              key={eachBusinessPlan.uuid}
              eachBusinessPlan={eachBusinessPlan}
              handleNavigate={handleNavigate}
            />
          ))}
        </Box>
      </ContentWrapper>
    </>
  );
};
